/**
 * Has dependency on floorplan-bundle.js
 */

const NS = 'PlanSectionService';

export default function PlanSectionService(
  SnapConst, SnapService, PlanConst, Group, Table, Structure, Divider, Door, Frame, TextOnly, $rootScope
) {
  "ngInject";

  function Section(s, mode, model) {
    this.s = s;
    this.mode = mode;
    this.model = model;
    this.model.type = Section.Type;
    this.model._id = this.model.section._id; //align to standard plan element for select/deselect behaviour
    this.selectedLayout = null;
    this.listeners = [];
    this.render();

    var _self = this;
    var destroy = $rootScope.$on('plan-destroy', function () {
      // Remove all listeners
      _.each(_self.listeners, function (listener) {
        listener();
      });
      // Remove this same function
      destroy();
    });
  }

  Section.prototype = {
    render: function () {
      //Main container
      this.item = new Group(this.s, 'section', this.model.box);
      this.item.buildRootElement();
      SnapService.place(this.item, this.model.section.position.x, this.model.section.position.y);
      this.content = new Group(this.s, 'content');
      SnapService.place(this.content, 0, 0);
      this.item.addElement(this.content.getSGroup(), 'content');
      this.label = new Group(this.s, 'labels');
      //Add layouts switcher
      var icon = this.s.image("images/view-list.svg", 0, 0, 24, 24);
      this.switcher = new Group(this.s, 'switcher', {
        type: SnapConst.Shapes.Rect,
        w: 24,
        h: 24
      });
      this.switcher.buildRootElement();
      this.switcher.addElement(icon, 'icon');
      this.label.addElement(this.switcher, 'switcher');
      this.listeners.push(SnapService.onClick(this.switcher, function (evt) {
        this.showLayoutList(evt);
      }, this));
      //Disable switcher
      if (_.size(this.model.layouts) <= 1) {
        SnapService.show(this.switcher, false);
      }
      //Display default layout
      this.showLayout(this.model.layouts[0]);
    },

    showLayoutList: function (evt) {
      if (!_.isEmpty(this.model.layouts)) {
        $rootScope.$broadcast('place-layouts-switcher', evt, this, this.model.layouts);
      }
    },

    showLayout: function (layout) {
      //Selective clear upon layout switch
      _.each(this.content.elements, function (e, k) {
        if (k !== 'root' || k !== 'lables') {
          this.content.removeElement(k);
        }
      }, this);
      //Save layout reference
      this.selectedLayout = layout;
      //Add structures to main container
      _.each(layout.structures, function (s) {
        var structure = null;
        switch (s.subType) {
          case Structure.SubTypes.Wall:
          case Structure.SubTypes.Window:
            structure = new Divider(this.s, this.mode, s);
            break;
          case Structure.SubTypes.DoorLeft:
          case Structure.SubTypes.DoorRight:
          case Structure.SubTypes.DoorDouble:
            structure = new Door(this.s, this.mode, s);
            break;
          case Structure.SubTypes.FrameRect:
          case Structure.SubTypes.FrameCircle:
            structure = new Frame(this.s, this.mode, s);
            break;
          case Structure.SubTypes.TextOnly:
            structure = new TextOnly(this.s, this.mode, s);
            break;
        }
        if (structure) {
          //Structure place and rotate itself after render
          this.content.addElement(structure.getElement(), s._id);
          SnapService.enableGestures(structure.getElement(), Section.contentEnabled);
        }
      }, this);
      //Add tables to main layout
      _.each(layout.tables, function (t) {
        var table = new Table(this.s, t, this.mode);
        this.content.addElement(table.getPlanTable(), t._id);
        table.rotate(t.rotation || 0);
        SnapService.place(table.getPlanTable(), t.position.x, t.position.y);
        SnapService.show(table.getPlanTable(), true);
        SnapService.enableGestures(table.getPlanTable(), Section.contentEnabled);
      }, this);

      //Selective clear labels container
      _.each(this.label.elements, function (e, k) {
        if (k !== 'switcher') {
          this.label.removeElement(k);
        }
      }, this);
      //Session label
      this.sessionLabel = this.s.text(0, 0, this.model.section.name).addClass('big');
      this.label.addElement(this.sessionLabel, 'session');
      //Layout label
      this.layoutLabel = this.s.text(0, 0, layout.name).addClass('small');
      this.label.addElement(this.layoutLabel, 'layout');
      //Message for repositioned tables
      this.message = this.s.text(0, 0, layout.repositionedTables ? '(Floor Plans not complete)' : '').addClass('message');
      this.label.addElement(this.message, 'message');
      //Place labels
      SnapService.place(this.sessionLabel, 0, 0);
      SnapService.place(this.layoutLabel, 2, 22);
      SnapService.place(this.message, 2, 42);
      SnapService.place(this.switcher, -24, -24);
    },

    centerLabel: function () {
      var boundingBox = SnapService.calcBBox(this.label.getSGroup(), false);
      var size = {
        w: boundingBox.width,
        h: boundingBox.height
      };
      SnapService.place(this.label, Math.max(((this.model.box.w - size.w) / 2), 0), Math.max(((this.model.box.h) / 2), 0));
    },

    getElement: function () {
      return this.item;
    },

    getId: function () {
      return this.model.section._id;
    }
  };

  /************************************************************************************************************************
   *************************************************************************************************************************
   STATIC ATTRIBUTES AND FUNCTIONS
   *************************************************************************************************************************
   ************************************************************************************************************************/

  Section.Type = 'section';

  Section.contentEnabled = false;

  Section.rootBBox = function (section) {
    var res = {
      x: Math.min(section.model.section.position.x, section.model.box.x),
      y: Math.min(section.model.section.position.y, section.model.box.y),
      x2: section.model.box.x2,
      y2: section.model.box.y2
    };

    res.w = res.x2 - res.x;
    res.h = res.y2 - res.y;
    return res;
  };

  return Section;
}
